export default __webpack_public_path__ + "static/media/bannerFourx2.18f6015f.png";